(() => {
  if (!document.documentElement.classList.contains('section-reveal-enabled')) return;

  const SELECTOR = '#MainContent > .shopify-section';
  const VISIBLE = 'section-reveal--visible';
  const DONE = 'section-reveal--done';

  const getScrollRoot = () => {
    const pageWrapper = document.querySelector('.page-wrapper');
    if (!pageWrapper) return null;

    const styles = window.getComputedStyle(pageWrapper);
    const canScrollY = styles.overflowY === 'auto' || styles.overflowY === 'scroll';
    if (canScrollY && pageWrapper.scrollHeight > pageWrapper.clientHeight + 1) {
      return pageWrapper;
    }

    return null;
  };

  const markDone = (section) => {
    section.classList.add(DONE);
    section.classList.add(VISIBLE);
  };

  const reveal = (section) => {
    if (section.classList.contains(VISIBLE) || section.classList.contains(DONE)) return;

    const finish = (event) => {
      if (event && event.target !== section) return;
      if (event && event.propertyName && event.propertyName !== 'opacity' && event.propertyName !== 'transform') {
        return;
      }
      section.removeEventListener('transitionend', finish);
      markDone(section);
    };

    section.addEventListener('transitionend', finish);
    section.classList.add(VISIBLE);

    window.setTimeout(() => markDone(section), 1500);
  };

  let observer = null;

  const createObserver = () => {
    if (observer) observer.disconnect();

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        root: getScrollRoot(),
        threshold: [0, 0.08, 0.15],
        rootMargin: '0px 0px -64px 0px',
      }
    );
  };

  const isInView = (section) => {
    const rect = section.getBoundingClientRect();
    const viewH = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < viewH * 0.92 && rect.bottom > 48;
  };

  const observeSection = (section) => {
    if (!(section instanceof HTMLElement)) return;
    if (section.classList.contains(DONE) || section.classList.contains(VISIBLE)) return;

    if (isInView(section)) {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => reveal(section));
      });
      return;
    }

    if (!observer) createObserver();
    observer.observe(section);
  };

  const init = () => {
    createObserver();
    document.querySelectorAll(SELECTOR).forEach(observeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!(section instanceof HTMLElement)) return;
    if (!section.matches(SELECTOR) && !section.classList.contains('shopify-section')) return;
    if (!section.closest('#MainContent')) return;
    section.classList.remove(VISIBLE, DONE);
    observeSection(section);
  });

  window.addEventListener(
    'orientationchange',
    () => {
      window.setTimeout(() => {
        createObserver();
        document.querySelectorAll(`${SELECTOR}:not(.${DONE}):not(.${VISIBLE})`).forEach((section) => {
          observeSection(section);
        });
      }, 250);
    },
    { passive: true }
  );

  window.setTimeout(() => {
    document.querySelectorAll(`${SELECTOR}:not(.${DONE})`).forEach(markDone);
  }, 5000);
})();
